import { type ComponentProps } from "react";

interface HeartProps extends ComponentProps<"svg"> {
  color?: string;
}

export const Heart = ({ color, ...props }: HeartProps) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99998 16.7394L4.21737 9.89122C3.71021 9.31918 3.37465 8.57626 3.25933 7.77015C3.144 6.96404 3.25491 6.13665 3.57597 5.4079V5.4079C3.82333 4.85572 4.18012 4.37814 4.61754 4.01374C5.05495 3.64933 5.56075 3.40829 6.09409 3.31009C6.62743 3.21188 7.17337 3.25926 7.68786 3.44839C8.20235 3.63752 8.67096 3.9631 9.05588 4.39887L9.99998 5.3889L10.9441 4.39887C11.329 3.96324 11.7977 3.63778 12.3121 3.44873C12.8266 3.25968 13.3725 3.21235 13.9058 3.31055C14.4391 3.40875 14.9449 3.64973 15.3823 4.01405C15.8197 4.37837 16.1765 4.85583 16.424 5.4079V5.4079C16.7449 6.1367 16.8557 6.96404 16.7403 7.7701C16.625 8.57615 16.2896 9.31906 15.7826 9.89122L9.99998 16.7394Z"
      stroke={props?.stroke ?? color ?? "var(--primary-color)"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={props?.fill ?? "none"}
    />
  </svg>
);